import React from 'react';
import './Newfeed.css';
import FeedSide from './FeedSide';
import FeedPost from './FeedPost';
import FeedMessage from './FeedMessage';

function Newfeed({userId, username, birthday, email, password, 
    profilePic, menuOpen, messOpen, menuopen, findFri}) {
    return (
        <div className="newfeed">
            <FeedSide 
                username = {username}
                profilePic = {profilePic}
                userId = {userId}
                menuOpen={menuOpen}
                menuopen={menuopen}
            />
            <FeedPost 
                username = {username}
                profilePic = {profilePic}
                userId = {userId}
                posttype = "blog"
            />
            <FeedMessage 
                messOpen={messOpen}
                findFri = {findFri}
                userId = {userId}
                email = {email}
            />
        </div>
    )
}

export default Newfeed
